import styled from 'styled-components';
import newArrow from 'assets/img/icons/new-arrow.png';

export const Container = styled.div`
  display: flex;
  flex: 1;
`;

export const SelectStyled = styled.select`
  width: 100%;
  height: 40px;
  border: 1px solid #cbcbcb;
  box-sizing: border-box;
  border-radius: 4px;

  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  padding-left: 15px;
  color: #a1a1a1;

  -moz-appearance:none;
  -webkit-appearance:none; 
  appearance:none;
  background: url(${newArrow}) no-repeat right #fff;
  background-position-x: 95%;
  
  :active{
    border: 1px solid #F08E31;
  }

  :hover{
    cursor: pointer;
  }
`;
